import React from 'react';
import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';

import { PRODUCT_FRAGMENT } from '../../../component/productPreview/ProductPreview';
import ProductsListItem from '../../../component/productsList/productsListItem/ProductsListItem';

import './PopularListings.css';

const POPULAR_PRODUCTS = gql`
    query PopularListings($filter: ProductFilter!, $sort: String!, $limit: Int!) {
        items: searchProducts(filter: $filter, sort: $sort, limit: $limit) {
            ...ProductFragment
            id
            createdAt
            category
            title
            brand
            price
            status
            external_url
            resizedSmallImages
            is_visible
            size
            condition
            discount_rate
            like_count
            is_liked
        }
    }
    ${PRODUCT_FRAGMENT}
`;

/**
 * 홈화면 인기 상품 섹션
 * @returns {JSX.Element}
 * @constructor
 */
export default function PopularListings() {
    const { data } = useQuery(POPULAR_PRODUCTS, {
        variables: {
            filter: {
                price_min: 100001,
                show_only: 'selling',
            },
            sort: 'POPULAR',
            limit: 6,
        },
        fetchPolicy: 'cache-and-network',
    });

    const items = data?.items ?? [];

    return (
        <section className="PopularListings">
            <div className="PopularListings-inner">
                <div className="PopularListings-header">
                    <div>
                        <div className="PopularListings-tag">Popular Listings</div>
                        <h2 className="PopularListings-title">인기 상품</h2>
                    </div>
                </div>
                <div className="PopularListings-grid">
                    {items.map((product) => (
                        <ProductsListItem key={product.id} product={product} />
                    ))}
                </div>
            </div>
        </section>
    );
}
